import React from "react";

import DeleteIcon from "@mui/icons-material/DeleteForeverRounded";
import { Button } from "@mui/material";
import { withStyles } from "tss-react/mui";

type Props = React.ComponentProps<typeof Button>;

const StyledButton = withStyles(Button, {
  root: {
    color: "#FF6262",
    borderColor: "#FF6262",
  },
});

const DeleteIconButton: React.FC<Props> = (props) => {
  return (
    <StyledButton
      size="small"
      variant="outlined"
      startIcon={<DeleteIcon fontSize="small" />}
      {...props}
    >
      Delete
    </StyledButton>
  );
};

export default DeleteIconButton;
